

<template>
  <div class="formWrap">
    <div class="scroll-container">
      <div class="sectionHeader">
        <div class="sectionTitle">项目基本信息</div>
        <div class="sectionDesc">
          请准确填写以下基础信息，以便系统为您生成更匹配的申报报告。
        </div>
        <div class="currentTypeTag">
          <i class="el-icon-collection-tag"></i>
          当前申报类型：{{ currentType }}
        </div>
      </div>
      <el-form
        :model="personaForm"
        ref="queryForm"
        :rules="rules"
        size="small"
        label-position="right"
        label-width="120px"
        class="simpleForm"
      >
        <div class="formGrid">
          <el-form-item label="单位名称" prop="corporateName">
            <el-input
              v-model="personaForm.corporateName"
              placeholder="请输入单位名称"
              clearable
              prefix-icon="el-icon-office-building"
            />
          </el-form-item>

          <el-form-item label="单位主营业务" prop="mainBusiness">
            <el-input
              v-model="personaForm.mainBusiness"
              placeholder="请输入主营业务"
              clearable
              type="textarea"
              maxlength="50"
              show-word-limit
              :rows="1"
              prefix-icon="el-icon- suitcase"
            />
          </el-form-item>

          <el-form-item label="项目名称" prop="entryName" class="fullRow">
            <el-input
              v-model="personaForm.entryName"
              placeholder="请输入项目名称"
              clearable
              prefix-icon="el-icon-document"
            />
          </el-form-item>

          <el-form-item label="项目介绍" prop="projectIntroduction" class="fullRow">
            <el-input
              v-model="personaForm.projectIntroduction"
              placeholder="请输入项目介绍（简述核心技术、路径及目标）"
              clearable
              type="textarea"
              maxlength="300"
              show-word-limit
              :rows="3"
            />
          </el-form-item>
        </div>

        <div class="unitsBlock">
          <div class="unitsHeader">
            <div class="unitsTitle">联合申报单位</div>
            <el-button type="primary" plain icon="el-icon-plus" size="small" @click="addUnits">添加</el-button>
          </div>

          <div v-if="personaForm.cooperativeUnits.length === 0" class="unitsEmpty">
            暂无联合申报单位
          </div>

          <div v-for="(unit, index) in personaForm.cooperativeUnits" :key="index" class="unitRow">
            <div class="unitRowTop">
              <div class="unitRowTitle">联合单位 #{{ index + 1 }}</div>
              <el-button type="text" class="unitDelete" icon="el-icon-delete" @click="removeUnit(index)">删除</el-button>
            </div>
            <div class="unitRowGrid">
              <el-form-item label="联合单位名称">
                <el-input v-model="unit.name" placeholder="请输入联合单位名称" clearable size="small" />
              </el-form-item>
              <el-form-item label="分工">
                <el-input v-model="unit.duty" placeholder="请输入分工工作（50字以内）" clearable size="small" maxlength="50" />
              </el-form-item>
            </div>

            <div class="unitRowActions" v-if="index === personaForm.cooperativeUnits.length - 1">
              <el-button type="primary" plain icon="el-icon-plus" size="small" @click="addUnit">继续添加</el-button>
            </div>
          </div>
        </div>
      </el-form>
    </div>

    <div class="actions">
      <el-button type="primary" class="submitBtn" @click="submitForm">提交申报</el-button>
      <el-button type="info" plain class="historyBtn" @click="toHistorical">查看历史申报记录</el-button>
    </div>
  </div>
</template>

<script>
import {addApplication} from "@/api/application";

export default {
  props: {
    currentType: {
      type: String,
      default: '中央引导地方发展科技资金'
    }
  },
  data() {
    return {
      showUnits:false,
      personaForm: {
        corporateName: '',
        entryName: '',
        projectIntroduction: '',
        cooperativeUnits: [], // 联合申报单位数组
        division:'',//分工
        mainBusiness:'',//主营业务
        price: ''//价格
      },
      declarationTypeMap: {
        '中央引导地方发展科技资金': 1,
        '专项资金申请': 2,
        '科小创新能力提升工程': 3,
        '山东省重点研发计划': 4,
        '鲁渝科技合作项目': 5,
        '黄河流域协同科技创新项目': 6,
        '泰安市科技创新双十工程项目': 7,
      },
      personaFormNull: {
        corporateName: '',
        entryName: '',
        projectIntroduction: '',
        cooperativeUnits: [], // 联合申报单位数组
        division:'',//分工
        mainBusiness:'',//主营业务
      },
      rules: {

        corporateName:[
          {
            required: true, message: "公司名称不能为空", trigger: "blur"}
        ],
        mainBusiness:[
          {
            required: true, message: "主营业务不能为空", trigger: "blur"}
        ],
        entryName:[
          {
            required: true, message: "项目名称不能为空", trigger: "blur"
          },
        ],
        projectIntroduction:[
          {
            required: true, message: "项目简介不能为空", trigger: "blur"
          },
        ],
        division:[
          {
            required: true, message: "主要分工不能为空", trigger: "blur"
          }
        ],
      },
    }
  },


  methods: {

    toHistorical(){
      this.$router.push({ path: 'declaration', query: { typePath: "1" } }).then(() => {
        window.location.reload();
      });
    },
    //清理personaForm表单
    cleanPersonaForm(){
      this.personaForm = this.personaFormNull;
    },

    //提交接口
    submitForm() {
      if (this.personaForm.corporateName === ''){
        this.$message({
          message: '单位名称不能为空',
          type: 'error',
          duration: 1500,
          showClose: true,
          offset: 200
        })
      }else if (this.personaForm.entryName === ''){
        this.$message({
          message: '项目名称不能为空',
          type: 'error',
          duration: 1500,
          showClose: true,
          offset: 200
        })
      }else if (this.personaForm.mainBusiness === null) {
        this.$message({
          message: '经营范围不能为空',
          type: 'error',
          duration: 1500,
          showClose: true,
          offset: 200
        })
      }else if (this.personaForm.projectIntroduction === null) {
        this.$message({
          message: '项目简介不能为空',
          type: 'error',
          duration: 1500,
          showClose: true,
          offset: 200
        })
      }else {

        var userId = localStorage.getItem("userId");
        if (userId == null) {
          this.$message({
            message: '您未登录账号，请登录或注册账号后进行申报',
            type: 'error',
            duration: 5000,
            showClose: true,
            offset: 200
          })
          return;
        }

        const body = {
          unitName: this.personaForm.corporateName,
          entryName: this.personaForm.entryName,
          declarationAccount: userId,
          declarationInformation: JSON.stringify(this.personaForm),
          declarationType: this.declarationTypeMap[this.currentType] || 1,
        }

        addApplication(body).then(res => {
          if (res.code === 200) {
            this.cleanPersonaForm();
            this.$message({
              message: '您的申请已提交，请耐心等待报告生成，请在历史生成记录查看',
              type: 'success',
              duration: 5000,
              showClose: true,
              offset: 200
            });
          }
        })
      }
    },
    addUnits() {
      this.personaForm.cooperativeUnits.push({ name: '', duty: '' });
      this.showUnits = true
    },
    addUnit() {
      this.personaForm.cooperativeUnits.push({
        name: '', // 单位名称
        duty: '', // 分工
      });
    },
    // 删除某个联合申报单位
    removeUnit(index) {
      console.log("index",index);
      this.personaForm.cooperativeUnits.splice(index, 1);
      if (index ===0){
        this.showUnits = false
      }
    },
  },
}
</script>
<style scoped lang="scss">
.formWrap {
  padding: 12px 4px 0;
}

.scroll-container {
  padding: 0;
  background: transparent;
}

.sectionHeader {
  margin-bottom: 18px;
  text-align: left;
}

.sectionTitle {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}

.sectionDesc {
  font-size: 16px;
  color: #6b7280;
}

.currentTypeTag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 6px 14px;
  background: linear-gradient(90deg, #2b6fff, #1f5bff);
  color: #fff;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(43, 111, 255, 0.25);
}

.simpleForm {
  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }

  ::v-deep .el-form-item__label {
    font-size: 18px !important;
    color: #334155 !important;
    font-weight: 600;
    text-align: left;
    padding: 0 12px 0 0 !important;
    line-height: 40px;
    display: flex;
    align-items: center;
    height: 40px;
  }

  ::v-deep .el-form-item.is-required .el-form-item__label:before {
    margin-top: 2px;
  }

  ::v-deep .el-input__inner {
    height: 40px !important;
    line-height: 40px !important;
    border-radius: 6px;
    border: 1px solid #dbeafe;
    background: #fff;
    font-size: 18px;
    transition: all 0.2s;
  }

  ::v-deep .el-textarea__inner {
    border-radius: 8px;
    border: 1px solid #dbeafe;
    background: #fff;
    font-size: 18px;
    transition: all 0.2s;
    padding: 5px 15px;
  }

  /* 针对文本域标签对齐第一行 */
  ::v-deep .el-form-item.fullRow .el-form-item__label {
    align-items: flex-start;
    line-height: 32px;
  }

  ::v-deep .el-input__inner:focus,
  ::v-deep .el-textarea__inner:focus {
    border-color: #2b6fff;
    box-shadow: 0 0 0 3px rgba(43, 111, 255, 0.12);
  }
}

.formGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 22px;
}

.fullRow {
  grid-column: 1 / -1;
}

.unitsBlock {
  margin-top: 20px;
  padding: 20px 18px 16px;
  border: 1px solid #e0edff;
  border-radius: 16px;
  background: #f5f9ff;
  box-shadow: 0 6px 18px rgba(148, 163, 184, 0.15);
}

.unitsHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.unitsTitle {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}

.unitsEmpty {
  font-size: 16px;
  color: #64748b;
  padding: 12px 0;
}

.unitRow {
  border-top: 1px solid #eef2f7;
  padding-top: 12px;
  margin-top: 12px;
}

.unitRowTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.unitRowTitle {
  font-size: 16px;
  font-weight: 700;
  color: #334155;
}

.unitDelete {
  color: #ef4444;
}

.unitRowGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 18px;
}

.unitRowActions {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.actions {
  margin-top: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.submitBtn {
  width: 260px;
  height: 46px;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 700;
  background: linear-gradient(90deg, #2b6fff, #1f5bff);
  border: none;
}

.historyBtn {
  width: 220px;
  border-radius: 999px;
}

@media (max-width: 980px) {
  .formGrid {
    grid-template-columns: 1fr;
  }

  .unitRowGrid {
    grid-template-columns: 1fr;
  }
}
</style>
